import React from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import loadable from '@loadable/component';

import { isScrollingDisabled } from '../../ducks/ui.duck';
import { useIntl, FormattedMessage } from '../../util/reactIntl';
import {
  Page,
  LayoutSingleColumn,
} from '../../components';
import FooterContainer from '../../containers/FooterContainer/FooterContainer';
import VacationModeToggle from './VacationModeToggle';

import css from './VacationModePage.module.css';

const TopbarContainer = loadable(
  () => import('../../containers/TopbarContainer/TopbarContainer')
);

/**
 * VacationModePage — account settings page for vacation/away mode.
 *
 * Linked from UserNav → "Vacation Mode" tab.
 * Stores vacationMode in currentUser.publicData.vacationMode
 */
const VacationModePageComponent = ({ currentUser, scrollingDisabled }) => {
  const intl = useIntl();
  const title = intl.formatMessage({ id: 'VacationModePage.title' });

  return (
    <Page title={title} scrollingDisabled={scrollingDisabled} className={css.root}>
      <LayoutSingleColumn
        topbar={<TopbarContainer />}
        footer={<FooterContainer />}
      >
        <div className={css.content}>
          <h1 className={css.heading}>
            <FormattedMessage id="VacationModePage.heading" />
          </h1>
          <p className={css.intro}>
            <FormattedMessage id="VacationModePage.intro" />
          </p>
          {currentUser?.id && (
            <VacationModeToggle currentUser={currentUser} />
          )}
        </div>
      </LayoutSingleColumn>
    </Page>
  );
};

const mapStateToProps = state => ({
  currentUser: state.user.currentUser,
  scrollingDisabled: isScrollingDisabled(state),
});

const VacationModePage = compose(connect(mapStateToProps))(VacationModePageComponent);
export default VacationModePage;
